<!-- 创始人说 -->
<template>
  <div class="frame">
    <img
      src="http://api.zyzxgc.cn/file/static/banner_about.jpg"
      class="banner"
    />
    <div class="breadcrumb w1200">
      <bread-crumb :breadcrumbs="routerHistory"></bread-crumb>
    </div>
    <sub-nav :subNavs="subNavs"></sub-nav>
    <div class="container w1200">
      <sub-title title="创始人说" en="THE FOUNDER SAID"></sub-title>
      <div class="content">
        <div class="flex">
          <div class="left">
            每一座建筑<br />
            都凝聚着建设者的匠造之心<br />
            正是这种匠心精神<br />
            创造了无数个令人叹为观止的建筑奇迹<br />
            指引着建设者们不断创造更大的辉煌<br />
            志扬咨询<br />
            志怀家国，扬发蹈厉<br />
            以真诚务实利他之心<br />
            以饱满的热情和匠心的专业<br />
            让每一座建筑<br />
            都最大化地绽放它应有的价值<br />
            让每一次期盼都圆满地实现<br />
            这就是<br />
            匠心咨询成就匠心建筑<br />
            ——王知平
          </div>
          <img
            src="http://api.zyzxgc.cn/file/static/leader.png"
            alt="领导人"
            class="right"
          />
        </div>
        <div class="say">
          <p>
            <span>【专注】</span>
            经政府平台、施工企业、咨询企业工程咨询行业历练，
            专注工程咨询行业20余载。
          </p>
          <p>
            <span>【专业】</span>
            独创工程咨询品质管理系统，建立业务流程、作业标准及操作规范。
          </p>
          <p>
            <span>【服务】</span>
            服务至今，无一重大投诉，实现续签率95%以上。
          </p>
          <p>
            <span>【责任】 </span>
            对社会：只要有需要，志扬人都会冲在最前线！
            对员工：帮助他们个人成长，助力实现个人的人生目标！
          </p>
        </div>
      </div>
    </div>
    <img
      src="http://api.zyzxgc.cn/file/static/leadersay_build.png"
      alt=""
      class="build"
    />
  </div>
</template>

<script>
import { Store } from "@/store/index.js";
import { mapState } from "pinia";
import breadCrumb from "@/components/breadCrumb.vue";
import SubNav from "@/components/subNav.vue";
import SubTitle from "@/components/subTitle.vue";
export default {
  components: { breadCrumb, SubNav, SubTitle },
  data() {
    return {
      routerHistory: [], // 当前所在位置
      subNavs: [],
    };
  },
  computed: {
    ...mapState(Store, ["navList"]),
  },
  created() {
    this.formatBreadCrumb();
  },
  mounted() {},
  methods: {
    // 格式化导航条和二级导航栏
    formatBreadCrumb() {
      let nav = this.navList.find(
        (ele) => ele.path != "/" && this.$route.path.includes(ele.path)
      );
      if (nav.subs && nav.subs.length != 0) {
        // 二级导航栏
        this.subNavs = nav.subs;
      }
      this.routerHistory = [{ path: "/", name: "首页" }, nav];
    },
  },
};
</script>

<style lang="scss" scoped>
.frame {
  .banner {
    width: 100%;
    display: block;
  }
  .breadcrumb {
    margin: 25px auto 20px;
  }
  .container {
    margin: 70px auto 10px;

    .flex {
      margin-top: 35px;
      display: flex;
      justify-content: center;
      align-items: center;

      .left {
        font-size: 15px;
        color: #5e5d5d;
        line-height: 30px;
        text-align: center;
      }
      .right {
        width: 580px;
        margin-left: 110px;
      }
    }
    .say {
      width: 820px;
      margin: 35px auto 0;

      p {
        line-height: 30px;
        font-size: 15px;
        color: #5e5d5d;

        span {
          color: $theme;
        }
      }
    }
  }
  .build {
    width: 100%;
    margin-bottom: 120px;
  }
}

@media (max-width: 750px) {
  .frame {
    .banner {
      height: auto;
    }
    .breadcrumb {
      display: none;
    }
    .container {
      margin: 20px 0;
      padding: 0 10px;
      box-sizing: border-box;

      .flex {
        margin-top: 10px;
        display: block;

        .right {
          width: 100%;
          margin-left: 0;
          margin-top: 20px;
        }
      }
      .say {
        width: 100%;
        margin-top: 20px;
      }
    }
    .build {
      margin-bottom: 20px;
    }
  }
}
</style>
